<script setup>
import {computed} from 'vue'
import {useRouter} from 'vue-router'
import UserTrackingAvatar from '@/common/UserTrackingAvatar'
import ThemesEditorEditBtn from './ThemesEditorEditBtn'
import ThemesEditorUsage from './ThemesEditorUsage'
import Button from "@/common/Button.vue"
import {useThemesStore} from '@/stores/themes'

const props = defineProps({
    item: {
        type: Object,
        required: true
    },
    activeEditorKey: {
        type: [Number, Boolean],
        default: false
    }
})

const router = useRouter()
const themesStore = useThemesStore()

// --- Computed ---

const tableName = computed(() => themesStore.tableName)
const editors = computed(() => themesStore.editors)
const sectionName = computed(() => themesStore.sectionName)
const navSearch = computed(() => themesStore.navSearch)
const sortAlpha = computed(() => themesStore.sortAlpha)

const isActive = computed(() => {
    const key = props.activeEditorKey
    const activeEditor = editors.value[key]

    return (
        key !== false &&
        activeEditor?.tableName === tableName.value &&
        activeEditor?.id === props.item.id
    )
})

// --- Methods ---

const onClick = () => {
    // Current navigation logic: updates URL which is then watched by the parent ThemesEditor
    if (themesStore.activeId !== props.item.id) {
        router.push({
            query: {
                section: sectionName.value,
                id: props.item.id
            }
        })
    }
}
</script>

<template>
    <Button
        :active-class="'btn-primary'"
        :active-value="isActive"
        class="w-100 text-start btn-sm p-1 ps-2 d-flex align-items-center visible-on-hover"
        @click.prevent="onClick"
    >
        <div class="flex-fill overflow-hidden text-nowrap small">
            <UserTrackingAvatar :item-id="item.id" :table-name="tableName"/>

            {{ item.title }}

            <span v-if="item.contentType && (sortAlpha || navSearch)"
                  class="ms-1 text-dark bg-secondary-subtle rounded p-1">
                {{ item.contentType }}
            </span>

            <span v-if="item.mode === 'text/x-scss'" class="ms-1 badge text-primary-emphasis">SCSS</span>
            <span v-if="item.mode === 'text/x-less'" class="ms-1 badge text-primary-emphasis">LESS</span>
        </div>

        <ThemesEditorEditBtn :item="item"/>

        <ThemesEditorUsage :id="item.id" class="ms-1"/>
    </Button>
</template>